module.exports = __webpack_public_path__ + "static/media/jason-momoa-loop-1.94d8a342.mp4";